import styled from 'styled-components';

import Button from '../Button';

export default styled(Button)`
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.COLOR_GRAY};
`;
